import { z } from 'zod'

import { DEFAULT_PAGE, DEFAULT_PER_PAGE } from '@/core/lib/pagination'

export const tableSearchSchema = z.object({
  page: z.coerce.number().int().positive().catch(DEFAULT_PAGE),
  per_page: z.coerce.number().int().positive().max(200).catch(DEFAULT_PER_PAGE),
  q: z.string().optional().catch(undefined),
  sort: z.string().optional().catch(undefined),
  order: z.enum(['asc', 'desc']).optional().catch(undefined),
})

export type TTableSearch = z.infer<typeof tableSearchSchema>

export const makeTableSearchSchema = <Extra extends z.ZodRawShape>(
  extra: Extra
) => tableSearchSchema.extend(extra)

// ---------------------------------------------------------------------------
// Structured search schema for server-side sort/filter list tables. URL search
// params carry `sort`/`filters` as objects (tanstack router serializes them);
// they are converted to the backend query string by `buildAdminListQuery`.

export const sortStateSchema = z.object({
  field: z.string(),
  order: z.enum(['asc', 'desc']),
})

export const filterStateSchema = z.record(
  z.string(),
  z.array(z.union([z.string(), z.number(), z.boolean()]))
)

export const adminListSearchSchema = z.object({
  page: z.number().int().positive().optional().catch(undefined),
  query: z.string().optional().catch(undefined),
  sort: sortStateSchema.optional().catch(undefined),
  filters: filterStateSchema.optional().catch(undefined),
})

export type TAdminListSearch = z.infer<typeof adminListSearchSchema>
